// src/rds_ui/api/promptApi.js
//
// Migrated off raw fetch() onto the shared axios instance in
// src/api/client.js (see projectsApi.js in this folder for why).
import { api } from "../../api/client";

const BASE = "/rds";

export async function fetchPrompts(projectId = null) {
  try {
    const res = await api.get(`${BASE}/prompts`, {
      params: projectId ? { project_id: projectId } : undefined,
    });
    return res.data;
  } catch {
    throw new Error("Failed to fetch prompts");
  }
}

export async function fetchPrompt(id) {
  try {
    const res = await api.get(`${BASE}/prompts/${id}`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch prompt");
  }
}

// Direct content update — used for project-specific rows or global rows on admin page
export async function updatePrompt(id, content) {
  try {
    const res = await api.put(`${BASE}/prompts/${id}`, { content });
    return res.data;
  } catch {
    throw new Error("Failed to update prompt");
  }
}

// Save edited content as a project-specific version (inactive by default)
// Called when user edits a global prompt and clicks Save in project context
export async function saveProjectVersion(globalPromptId, projectId, content) {
  try {
    const res = await api.post(`${BASE}/prompts/${globalPromptId}/save-version`, {
      project_id: projectId,
      content,
    });
    return res.data;
  } catch {
    throw new Error("Failed to save project version");
  }
}

export async function deletePrompt(id) {
  try {
    await api.post(`${BASE}/prompts/${id}/reset`);
  } catch {
    throw new Error("Failed to delete prompt");
  }
}

// Override on a project-specific row: activate it for the project
export async function activatePrompt(id) {
  try {
    const res = await api.post(`${BASE}/prompts/${id}/activate`);
    return res.data;
  } catch {
    throw new Error("Failed to activate prompt");
  }
}

// Override on a global row: deactivate project-specific row (revert to global)
export async function deactivateProjectOverride(globalPromptId, projectId) {
  try {
    await api.post(`${BASE}/prompts/${globalPromptId}/deactivate-override`, {
      project_id: projectId,
    });
  } catch {
    throw new Error("Failed to deactivate override");
  }
}

export async function previewPrompt({ artifactType, methodology, serviceLineCodes, sampleContentJson, sampleFeedback }) {
  try {
    const res = await api.post(`${BASE}/prompts/preview`, {
      artifact_type: artifactType,
      methodology: methodology,
      service_line_codes: serviceLineCodes || [],
      sample_content_json: sampleContentJson || null,
      sample_feedback: sampleFeedback || "Improve this artifact",
    });
    return res.data;
  } catch {
    throw new Error("Failed to preview prompt");
  }
}
